import { Component, OnInit } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { DataCafService } from 'src/app/services/data-caf.service';
import { DataCAF } from 'src/app/shared/object/data_caf.model';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-table-view-folios',
  templateUrl: './table-view-folios.component.html',
  styleUrls: ['./table-view-folios.component.scss']
})
export class TableViewFoliosComponent implements OnInit {
  listDataCaf: DataCAF[];
  groupedDataCaf: any[];
  loading: boolean;
  listOrderDTE: number[];

  constructor(
    private accesolocalstorage: SecurityService,
    private dataCafService: DataCafService,
    private toastService: ToastService,
  ) {
    this.loading = false;
    this.listOrderDTE = [
      33, 61, 52, 56
    ]
    this.groupedDataCaf = [];
    // this.listDataCaf = [
    //   {
    //     codigoDTE: 33,
    //     nombreDTE: "Factura Electrónica",
    //     fechaVencimiento: "2024-09-19T00:00:00",
    //     foliosDisponibles: 540,
    //     ultimoFolio: 310068,
    //     folioInicial: 302609,
    //     folioFinal: 310608,
    //   },
    //   {
    //     codigoDTE: 34,
    //     nombreDTE: "Factura No Afecta o Exenta Electrónica",
    //     fechaVencimiento: "2024-09-19T00:00:00",
    //     ultimoFolio: 310068,
    //     foliosDisponibles: 540,
    //     folioInicial: 302609,
    //     folioFinal: 310608,
    //   },
    //   {
    //     codigoDTE: 46,
    //     nombreDTE: "Factura de Compra Electrónica",
    //     fechaVencimiento: "2024-09-19T00:00:00",
    //     ultimoFolio: 310068,
    //     foliosDisponibles: 540,
    //     folioInicial: 302609,
    //     folioFinal: 310608,
    //   },
    //   {
    //     codigoDTE: 52,
    //     nombreDTE: "Guía de Despacho Electrónica",
    //     fechaVencimiento: "2024-09-19T00:00:00",
    //     ultimoFolio: 310068,
    //     foliosDisponibles: 540,
    //     folioInicial: 302609,
    //     folioFinal: 310608,
    //   },
    //   {
    //     codigoDTE: 56,
    //     nombreDTE: "Nota de Débito Electrónica",
    //     fechaVencimiento: "2024-09-19T00:00:00",
    //     ultimoFolio: 310068,
    //     foliosDisponibles: 540,
    //     folioInicial: 302609,
    //     folioFinal: 310608,
    //   },
    //   {
    //     codigoDTE: 61,
    //     nombreDTE: "Nota de Crédito Electrónica",
    //     fechaVencimiento: "2024-09-19T00:00:00",
    //     ultimoFolio: 310068,
    //     foliosDisponibles: 540,
    //     folioInicial: 302609,
    //     folioFinal: 310608,
    //   }
    // ]
  }

  ngOnInit() {
    this.loading = true;
    this.obtenerFolios();
  }
  obtenerFolios() {
    const fecha = new Date().toISOString();
    const rut_empresa = this.accesolocalstorage.getRutEmpresa();
    const inputParams = {
      entidad: {
        codigo_dte: 0,
        nombre_dte: fecha,
        fecha_emision: fecha,
        fecha_vencimiento: fecha,
        folios_disponibles: 0,
        ultimo_folio: 0,
        folios_inicial: 0,
        folios_final: 0,
        codigos_dte: '0',
        rut_empresa,
      }
    }
    this.dataCafService.getAllDataCaf(inputParams, (response) => {
      const { respuesta } = response;
      if (!respuesta) this.toastService.error('Error al consultar los folios.', 'Error', { timeOut: 5000 });
      else if (respuesta[0].errorEnProceso) 
        this.toastService.error('No existen folios en el ambiente: '+respuesta[0].errorEnProceso, 'Error de ambiente', { closeButton: true });
      else {
        this.listDataCaf = respuesta.map((x:any) => ({
          codigo_dte: x.codigo_dte,
          nombre_dte: x.nombre_dte,
          folios_disponibles: x.folios_disponibles,
          fecha_emision: x.fecha_emision,
          fecha_vencimiento: x.fecha_vencimiento,
          folios_inicial: x.folios_inicial,
          folios_final: x.folios_final,
          ultimo_folio: x.ultimo_folio,
        }))
      }
      this.listOrderDTE.forEach(dte => {
        const dataCaf = this.listDataCaf.filter(x => x.codigo_dte === dte);
        this.groupedDataCaf.push({
          codigo_dte: dte,
          nombre_dte: dataCaf[0].nombre_dte,
          items: [...dataCaf],
        });
      })
      console.log(this.groupedDataCaf);
      this.loading = false;
      // this.groupedDataCaf = this.groupBy(this.listDataCaf, 'nombre_dte');
    }) 
  }
  groupBy(array: any[], key: string) {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  }
  // obtenerProgress(dataCAF: DataCAF){
  //   const diferenciaFolios = dataCAF.folioFinal - dataCAF.folioInicial;
  //   return (dataCAF.ultimoFolio - diferenciaFolios) * 100;
  // }
}
